const getDetailsLogTriggerMessage = (triggerStep) => {
  if (triggerStep?.workflowName) {
    return `${triggerStep?.workflowName} workflow`;
  }

  if (triggerStep?.appSlug === 'webhook') {
    return triggerStep?.isSynchronousWebhook ? 'Synchronous Webhook' : 'Webhook';
  }

  if (triggerStep?.appSlug === 'schedule') {
    return `Schedule - ${triggerStep?.message}`;
  }

  return triggerStep?.message;
};

export default getDetailsLogTriggerMessage;
